import { render } from "./ListContainer.vue?vue&type=template&id=954a9e52"
import script from "./ListContainer.vue?vue&type=script&lang=js"
export * from "./ListContainer.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__